export default __webpack_public_path__ + "static/media/Beard_9_C3.83b45ee5.svg";